export default __webpack_public_path__ + "static/media/custodyBanner.b5d82f9a.png";